/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Hidden from "@insite/mobius/Hidden";
import MobiusLink from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    isPunchOutSession: getIsPunchOutSession(state),
});

const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SignOutLinkStyles {
    signOutWrapper?: InjectableCss;
    signOutLink?: LinkStyle;
    signOutText?: TypographyPresentationProps;
}

export const signOutLinkStyles: SignOutLinkStyles = {
    signOutWrapper: {
        css: css`
            display: inline-flex;
            padding: 6px 0;
            flex-direction: column;
        `,
    },
    signOutText: {
        css: css`
            margin-top: 2px;
        `,
    },
};

export const SignOutLink: FC<Props> = ({
    userName,
    currentUserIsGuest,
    isPunchOutSession,
    cancelPunchOut,
    signOut,
}) => {
    const styles = useMergeStyles("link", signOutLinkStyles);

    const onSignOutHandler = () => {
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    return (
        <>
            {userName && !currentUserIsGuest && (
                <Hidden above="sm" {...styles.signOutWrapper}>
                    <MobiusLink {...styles.signOutLink} href="/" onClick={onSignOutHandler}>
                        <Typography as="span" {...styles.signOutText}>
                            {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                        </Typography>
                    </MobiusLink>
                </Hidden>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SignOutLink),
    definition: {
        group: "Basic",
        icon: "link",
    },
};

export default widgetModule;
